export const mobileE164PrettyPrint = (mobile) => {
    if (mobile.startsWith('+886')) {
        const matches = mobile.match(/^(\+\d{3})(\d{3})(\d{3})(\d{3})$/);
        if (matches) {
            return `(${matches[1]}) ${matches[2]} ${matches[3]} ${matches[4]}`;
        }
    } else if (mobile.startsWith('+852')) {
        const matches = mobile.match(/^(\+\d{3})(\d{4})(\d{4})$/);
        if (matches) {
            return `(${matches[1]}) ${matches[2]} ${matches[3]}`;
        }
    } else if (mobile.startsWith('+60')) {
        const matches = mobile.match(/^(\+\d{2})(\d{2})(\d{4})(\d{4})$/);
        if (matches) {
            return `(${matches[1]}) 0${matches[2]}-${matches[3]} ${matches[4]}`;
        }
        const matches2 = mobile.match(/^(\+\d{2})(\d{2})(\d{3})(\d{4})$/);
        if (matches2) {
            return `(${matches2[1]}) 0${matches2[2]}-${matches2[3]} ${matches2[4]}`;
        }
    }
    return mobile;
};
